import React, { useState, useMemo } from "react";
import styles from "./style.module.scss";
import RaceDataTable from "../RaceDataTable";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { getDefaultDriverPreference } from "../../../utils/preferences";

export default function RaceDataContainer() {
  const jagDrivers = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.jagDrivers,
  );

  const [selectedCar, setSelectedCar] = useState<string>(
    () => getDefaultDriverPreference() ?? Object.keys(jagDrivers)[0] ?? "",
  );

  const driverInfo = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.driverInfo,
  );

  const carOptions = useMemo(() => {
    return Object.entries(jagDrivers)
      .filter(([, driverNumber]) => driverNumber)
      .map(([carKey, driverNumber]) => {
        const driver = driverNumber ? driverInfo[driverNumber] : undefined;
        const colour = driver?.driverHighlightColourAlt || "#888";
        return {
          value: carKey,
          label: driver?.driverName || "",
          colour,
        };
      });
  }, [jagDrivers, driverInfo]);

  return (
    <div className={styles.container}>
      <div className={styles.carSelector}>
        {carOptions.map((car) => (
          <label key={car.value} className={styles.carOption}>
            <input
              type="radio"
              name="carColour"
              value={car.value}
              checked={selectedCar === car.value}
              onChange={() => setSelectedCar(car.value)}
            />
            <span style={{ color: car.colour }}>{car.label}</span>
          </label>
        ))}
      </div>
      <div className={styles.tableWrapper}>
        <RaceDataTable key={selectedCar} carColour={selectedCar} />
      </div>
    </div>
  );
}
